import React, {useEffect,useState} from 'react';
import './lisensregistrering.scss';
import {JegerwebApiService} from '../../services/api-service/jegerweb-api-service';
import {useHistory, useLocation, useParams} from 'react-router-dom';
import FileSaver from 'file-saver';
import StartRegistrering from './registreringssider/startregistrering';
import VelgArt from './registreringssider/velgart';
import Bekreft from './registreringssider/bekreft';
import {useLisensContext} from '../lisenscontext/lisenscontext';

const LisensRegistrering = (props) => {
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const [data] = useLisensContext();
  const eksisterendeLisenser = data.lisenser.filter(art => art.arter === 1);
  const [lisensArter, setLisensArter] = useState(data.lisenser);
  const [currentPage, setCurrentPage] = useState('');


  useEffect(() => {
    setLisensArter(data.lisenser);
  }, [data]);

  useEffect(()=>{
    if (location.hash === '#maincontent') {
      document.getElementById('title').scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replace({path: history.location.pathname, hash: currentPage.toString()});
    }
  },[location,history,currentPage]);


  const abort = () => {
    setLisensArter(data.lisenser);
    setCurrentPage('');
    history.push(history.location.pathname);
  };
  const choice = () => {
    setCurrentPage('ArtValg');
    history.push({path: history.location.pathname, hash: 'ArtValg'});
  };
  const confirm = () => {
    setCurrentPage('Bekreftelse');
    history.push({path: history.location.pathname, hash: 'Bekreftelse'});
  };


  const updateLicence = () => {
    const lisenser = lisensArter.filter(art => art.arter === 1).filter(art => !eksisterendeLisenser.includes(art)).map(art => {
      return {
        ...art,
        arter: 0
      };
    });
    const sendArray = {lisenser, 'lang': params.lang};
    JegerwebApiService.put('/lisensjeger/:sessiontype/save/', sendArray)
      .then(() => {
        props.getLisensData();
        abort();
      }).catch(err => {
        console.error('Nettverksfeil: Vi har problemer med å koble til. Prøv igjen senere', err);
      });
  };


  const checkboxToggle = (artId) => {
    const licenceArray = lisensArter.map(art => {
      if (art.beskrivelse === artId.beskrivelse) {
        if (art.arter === 0) {
          return {
            ...art,
            arter: 1
          };
        } else {
          return {
            ...art,
            arter: 0
          };
        }
      } else {
        return art;
      }
    });
    setLisensArter(licenceArray);
  };
  const pdfDownload = () => {
    JegerwebApiService.get('/pdf/:sessiontype/lisensbrev/:lang',  {responseType: 'blob'})
      .then((response) => {
        const pdfBlob = new Blob([response.data]);
        FileSaver.saveAs(pdfBlob, data.jegernr + '-lisens.pdf');
      }).catch(err => {
        console.error('Nettverksfeil: Vi har problemer med å koble til. Prøv igjen senere', err);
      });
  };


  return (
    <section className='registration'>
      {history.location.hash === ''  &&
        <StartRegistrering eksisterendeLisenser={eksisterendeLisenser}
                           pdfDownload={pdfDownload}
                           nextPage={choice}
                           jaktaar={data.jaktaar}/>}

      {history.location.hash === '#ArtValg' &&
        <VelgArt eksisterendeLisenser={eksisterendeLisenser}
                 nextPage={confirm}
                 abort={abort}
                 checkboxToggle={checkboxToggle}
                 lisensArter={lisensArter}
                 redirectURL={history.location.pathname}
                 jaktaar={data.jaktaar}/>}

      {history.location.hash === '#Bekreftelse' &&
        <Bekreft eksisterendeLisenser={eksisterendeLisenser}
                 back={choice}
                 abort={abort}
                 lisensArter={lisensArter}
                 updateLicence={updateLicence}
                 jaktaar={data.jaktaar}/>}
    </section>
  );
};
export default LisensRegistrering;
